const sanityClient = require("@sanity/client");
const client = sanityClient({
  projectId: "73pn035v",
  dataset: "production",
  //token: "sanity-auth-token", // or leave blank to be anonymous user
  useCdn: false, // `false` if you want to ensure fresh data
});

export default client;
